const colors = {
  white: "#fff",
  darkWhite: "#eee",
  backgroundGrey: "#dcdfda",
  veryLightGrey: "#ddd",
  lightGrey: "#ccc",
  smallLightGrey: "#bbb",
  grey: "#aaa",
  medium1Grey: "#555",
  mediumGrey: "#666",
  medium2Grey: "#888",
  mediumDrakGrey: "#999",
  darkGrey: "#333",
  primaryVeryLight: "#ebc6b7",
  primaryLight2: "#e0a993",
  primaryLight: "#db9b81",
  primaryMediumLight: "#d68d6f",
  primary: "#CC704B",
  primaryDark: "#b86544",
  primaryVariantLight: "#d17e5d",
  primaryVariantDark: "#a35a3c",
  secondaryVeryLight: "#96a08f",
  secondaryLight: "#85907c",
  secondaryMediumLight: "#738069",
  secondaryMedium: "#48563d",
  secondary: "#506044",
  secondaryDark: "#404d36",
  secondaryVariantLight: "#9fc088",
  secondaryVariant: "#627057",
  backgroundLight: "#fefdfa",
  background: "#fdfaf5",
  backgroundMedium: "#fefcfa",
  backgroundMediumDark: "#f9eedb",
  backgroundDark: "#faf2e5",
  backgroundVeryDark: "#fbf5ea",
  backgroundModal: "#fffefc",
  background2: "#f6e5df",
  iconsLight: "#fbf3e5",
  error: "#ff0033",
  veryLightRed: "#f9625b",
  lightRed: "#f85149",
  red: "#b83b3b",
  green: "#20640c",
  flashGreen: "#55c57a",
  flashRed: "#f43535",
};

export default colors;
